"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const HTMLEntityStringUtil_1 = tslib_1.__importDefault(require("../deprecated/HTMLEntityStringUtil"));
class StringUtils {
    /**
     * Searches input text for long words that should be broken.
     * If unbroken character sections are longer than 'maxUnbroken' characters
     * they will be broken with a hyphenation character ('-') after 'breakPosition'
     * characters.
     * <p>
     * The following characters are considered as breaks in a string:
     *  space (' '), tab (\t), newline (\n), carriage return (\r), linefeed (\f) and hyphen ('-').
     *
     * @param text The input text to search for long words in.
     * @param breakPosition The position at which to insert a hyphenation character.
     * @param maxUnbroken The maximal length of unbroken charaters.
     * @param hyphen add hyphen.
     * @return A string with the same context as the input text, except that long words
     * 		have been broken with hyphenation characters.
     */
    static breakLongWords(text, breakPosition, maxUnbroken, hyphen) {
        if (breakPosition > maxUnbroken) {
            throw new Error(`breakPosition must be less or equal to maxUnbroken (${breakPosition} > ${maxUnbroken})`);
        }
        if (!text) {
            return text;
        }
        if (text.length <= maxUnbroken) {
            return text;
        }
        let b = "";
        text.split(" \t\n\r\f-").forEach((token) => {
            let offset = 0;
            while (token.length - offset > maxUnbroken) {
                b += token.substring(offset, offset + breakPosition);
                b += hyphen;
                offset += breakPosition;
            }
            b += token.substring(offset);
        });
        return b;
    }
    static breakLongWordsHtmlEntitySafe(text, breakPosition, maxUnbroken, hyphen) {
        if (breakPosition > maxUnbroken) {
            throw new Error(`breakPosition must be less or equal to maxUnbroken (${breakPosition} > ${maxUnbroken})`);
        }
        if (!text) {
            return text;
        }
        if (text.length <= maxUnbroken) {
            return text;
        }
        let b = "";
        text.split(" \t\n\r\f-").forEach((token) => {
            if (!token.trim() || token === "-") {
                b += token;
            }
            else {
                b += HTMLEntityStringUtil_1.default.withInput(token).hyphenate(maxUnbroken, breakPosition, hyphen);
            }
        });
        return b;
    }
    static extractFirstLine(s) {
        if (!s) {
            return s;
        }
        const i1 = s.indexOf("\r");
        const i2 = s.indexOf("\n");
        if (i1 !== -1) {
            if (i2 !== -1 && i2 < i1) {
                return s.substring(0, i2);
            }
            return s.substring(0, i1);
        }
        if (i2 !== -1) {
            return s.substring(0, i2);
        }
        return s;
    }
    static firstToLower(s) {
        return s && s[0].toLowerCase() + s.slice(1);
    }
    static firstToUpper(s) {
        if (!s) {
            return "";
        }
        else {
            const result = s.trim();
            return (result !== "") ? result[0].toUpperCase() + result.slice(1) : "";
        }
    }
    static isEmpty(str) {
        return (!str || 0 === str.length);
    }
    static isBlank(str) {
        return (!str || /^\s*$/.test(str));
    }
    static onlyContainsDigits(str) {
        return /^\d+$/.test(str);
    }
}
exports.default = StringUtils;
//# sourceMappingURL=StringUtils.js.map